import { employeesSelectors } from '~/store';
import { HEALTH_BAR_SINGLE_DASH_VALUE } from '~/lib/constants';
// ---- internal imports ----

const FINANCIAL_REASONS_REDUCTION_FOR_EACH_TURN = 2 * HEALTH_BAR_SINGLE_DASH_VALUE;

export function getHealth(state) {
	return state.playerHealth.health;
}

export function didUiHandleLatestChange(state) {
	return state.playerHealth.didUiHandleLatestChange;
}

export function hasEnoughHealthForNextTurn(state) {
	const health = getHealth(state);

	const nextMonthHealthDeduction = getNextMonthHealthDeduction(state);

	return health > nextMonthHealthDeduction;
}

export function getNextMonthHealthDeduction(state) {
	let deduction = FINANCIAL_REASONS_REDUCTION_FOR_EACH_TURN;

	if (!employeesSelectors.hasBookkeeper(state)) {
		deduction += HEALTH_BAR_SINGLE_DASH_VALUE;
	}

	if (!employeesSelectors.hasSalesman(state)) {
		deduction += HEALTH_BAR_SINGLE_DASH_VALUE;
	}

	return deduction;
}
